// extracted by mini-css-extract-plugin
export default {"root":"EventLayout_root__4BSAX","options":"EventLayout_options__NZ6Pq","content":"EventLayout_content__1Xz6o","header":"EventLayout_header__2Q3CA"};